import request from "@/utils/request";

export default {
    queryReport(param) {
        return request({
            url: "/process-sensory-report/query",
            method: "POST",
            data: param
        })
    },
    deleteReportForDraft(ttSensoryReportId) {
        return request({
            url: `/process-sensory-report/deleteReportForDraft/${ttSensoryReportId}`,
            method: "get",
        })
    },
    getDetail(id) {
        return request({
            url: "/process-sensory-report/queryDetailByReportId",
            method: "POST",
            data: id
        })
    },
    save(data) {
        return request({
            url: "/process-sensory-report/draft",
            method: "POST",
            data: data
        })
    },
    submit(data) {
        return request({
            url: "/process-sensory-report/submit",
            method: "post",
            data: data
        })
    },
    inactive(id, reason) {
        return request({
            url: `/process-sensory-report/inactive/${id}`,
            method: "post",
            data: reason
        })
    },
    exportList(param) {
        return request({
            url: `/process-sensory-report/export`,
            method: "post",
            data: param,
            responseType: 'blob',
            fullResponse: true,
        })
    },
    exportDetail(id) {
        return request({
            url: `/process-sensory-report/exportDetail/${id}`,
            method: "get",
            responseType: 'blob',
            fullResponse: true,
        })
    },
    exportPrintExcel(param) {
        return request({
            url: `/process-sensory-report/exportPrintExcel`,
            method: "post",
            data: param,
            responseType: 'blob',
            fullResponse: true,
        })
    },
    // 查询已配置的供应商评估人
    querySensoryRaters: (params) => {
        return request({
            url: "/sensory-supplier-rater/raters",
            method: "post",
            data: params
        })
    },
    // 查询可选择的供应商评估人
    querySensoryRatersCandidates: (params) => {
        return request({
            url: "/sensory-supplier-rater/candidates",
            method: "post",
            data: params
        })
    },
    // 删除供应商评估人
    delSensoryRaters: (params) => {
        return request({
            url: "/sensory-supplier-rater",
            method: "delete",
            data: params
        })
    },
    // 添加供应商评估人
    addSensoryRaters: (params) => {
        return request({
            url: "/sensory-supplier-rater",
            method: "post",
            data: params
        })
    },
    // 变更
    changeSensory: (reportId) => {
        return request({
            url: `/process-sensory-report/revise?reportId=${reportId}`,
            method: "put",
        })
    },
    // 导出评分明细
    exportSensoryDetail(sensoryReportId) {
        return request({
            url: `/process-sensory-report/exportDetail/${sensoryReportId}`,
            method: "get",
            responseType: 'blob',
            fullResponse: true,
        })
    },
    // 下载导入模板
    exportForUpload(sensoryReportId) {
        return request({
            url: `/process-sensory-report/exportForUpload/${sensoryReportId}`,
            method: "get",
            responseType: 'blob',
            fullResponse: true,
        })
    },
}